import { ClientCheckbox } from "../inputs/ClientCheckbox";
import { ClientPillButton } from "../inputs/ClientButtons";
import { NonInputFieldLabelWrapper } from "./NonFunctionalFieldLabel";
import { resolveValue } from "../../lib/fields/MultipleChoice/validity";
const filterMultiOptions = options => {
  let i = 0;
  return options.reduce((acc, {
    text
  }, i) => {
    if (text) {
      acc.push({
        label: text,
        value: i++
      });
    }
    return acc;
  }, []);
};
const CheckboxOptionsPreview = ({
  update,
  options = [],
  value: selectedValue,
  guid,
  onBlur
}) => {
  return <div className="preview--checkboxes--wrapper">
      {options.length ? options.map((entry, i) => {
      const {
        label,
        value
      } = entry;
      const choiceID = `${guid}-${value}`;
      const selected = selectedValue.includes(label);
      return <ClientCheckbox checked={selected} id={choiceID} onChange={() => {
        const newList = !selected ? [...selectedValue, label] : selectedValue.filter(option => option !== label);
        update(newList);
        onBlur();
      }} label={label} key={`checkbox-${guid}-${i}`} />;
    }) : ''}
    </div>;
};
export const ButtonsPreview = ({
  update,
  options = [],
  value: selectedValue = [],
  onBlur
}) => {
  return <div className="preview--buttons--wrapper">
      {options.length ? options.map((entry, i) => {
      const {
        label,
        value
      } = entry;
      const choiceID = `${label.split(' ').join('-').toLowerCase()}-${value}`;
      const selectedOption = selectedValue.includes(label);
      return <ClientPillButton key={`button-${i}`} id={choiceID} label={label} className={`${selectedOption ? 'selected' : ''}`} onClick={() => {
        const newList = !selectedOption ? [...selectedValue, label] : selectedValue.filter(option => option !== label);
        update(newList);
        onBlur();
      }} />;
    }) : ''}
    </div>;
};
export const MultipleChoicePreview = previewEntry => {
  const {
    style,
    required,
    label,
    errors,
    entry_values: options,
    value,
    default: defaultValue
  } = previewEntry;
  const MultipleChoiceComponent = style == 2 ? CheckboxOptionsPreview : ButtonsPreview;
  const filteredOptions = filterMultiOptions(options);
  const defaultOption = resolveValue(value || defaultValue, filteredOptions);
  return <div className="preview--wrapper">
      <NonInputFieldLabelWrapper required={required} label={label} error={errors} errorText={errors}>
        <MultipleChoiceComponent {...previewEntry} value={defaultOption} options={filteredOptions} />
      </NonInputFieldLabelWrapper>
    </div>;
};